import React, { Component } from 'react';
import { APP_URL_API } from '../../../setup/configs'
import Header from '../../common/Header';
import Settings from './sections/Settings';
import SelectOrganization from './sections/SelectOrganization';
import Information from './sections/Information';
import Regulations from './sections/Regulations';
import Beliefs from './sections/Beliefs';
import Rituals from './sections/Rituals';
import Reports from './sections/Reports';
import FooterButtons from './sections/FooterButtons';
import PrivacyAlert from './sections/PrivacyAlert';
import Alert from './sections/Alert';
import Info from './sections/Info';
import Modal from '../../../ui/modal/Modal';
import axios from 'axios';
import withAuth from '../../auth/withAuth';

const FormErrors = ({formErrors}) =>
  <div className='formErrors'>
    {Object.keys(formErrors).map((fieldName, i) => {
      if(formErrors[fieldName].length > 0){
        return (
          <p key={i}>{fieldName} {formErrors[fieldName]}</p>
        )
      } else {
        return '';
      }
    })}
  </div>

let organizationValues = {};
organizationValues = {
        id: 0,
        category_id: 5,
        type: null,
        name: '',
        approved_at: '',
        address: '',
        city: '',
        zip_code: '',
        website: '',
        vat_number: '',
        contact_name: '',
        contact_email: '',
        contact_phone: '',
        accounting_period_begin: '',
        accounting_period_end: '',
        is_public: 0,
        parent_id: null,
        documents: {
          regulations: [],
          beliefs: [],
          rituals: [],
          annualReports: [],
          donations: [],
        },
        memberships: []
      }
let fileValues = {};
fileValues = {
        beliefs:  {
          file: ''
        },
        rituals:  {
          file: ''
        },
        regulations: {
          file: '',
          comment: ''
        },
        annualReport: {
          file: '',
          year: 0,
          donations: '',
          donationsGreaterThan20000: null
        },
        donations: {
          file: '',
          year: 0
        }
      }
/*

OrganizationCreateOrEdit is wrapped in a HoC (Higher order component). This component takes care of checking if user is
logged in and retrieves the user type. If user is not logged in, he/she is sent to the login form.

OrganizationCreateOrEdit takes care of a lot of things, when creating and editing communities or congregations.

Mainly it saves a units organization- and contact info. It also handles file uploads. Its important to understand that files are not
uploaded before the editor click the Save button.

*/

class OrganizationCreateOrEdit extends Component {
	constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      isUploadingFile: false,
      formDataUpdated: false,
      formValid: false,
      dataFetched: false,
      showAlertModal: false,
      showInfoModal: false,
      modalText: '',
      organizationData: organizationValues,
      originalApprovedAt: '',
      files: JSON.parse(JSON.stringify(fileValues)),
      memberships: [],
      organizationTypes: [],
      attachedCongregations: [],
      btnSubmitDisabled: false
    }

    this.onValidateForm = this.onValidateForm.bind(this);
    this.onHandleApproveDocument = this.onHandleApproveDocument.bind(this);
    this.onHandleDeleteDocument = this.onHandleDeleteDocument.bind(this);
    this.onHandleAttachCommunity = this.onHandleAttachCommunity.bind(this);
    this.onHandleAttachCongregation = this.onHandleAttachCongregation.bind(this);
    this.onHandleRegretAttachingCommunity = this.onHandleRegretAttachingCommunity.bind(this);
    this.onHandleDetachCongregation = this.onHandleDetachCongregation.bind(this);
    this.onChangeAccountingDate = this.onChangeAccountingDate.bind(this);
  }

  // LIFE CYCLE FUNCTIONS

  componentDidMount() {
    this.getOrganization(parseInt(this.props.match.params.id))
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.match.params.id !== this.props.match.params.id) {
      this.setState({
        dataFetched: false
      }, this.getOrganization(parseInt(this.props.match.params.id)))
    }
  }

  // HELPER FUNCTIONS

  transformDateToYear(_date) {
    let transformedDate = '';
    transformedDate = _date.split("T");
    transformedDate = transformedDate[0].split("-");
    transformedDate = transformedDate[0];
    return transformedDate;
  }

  transformYearToDate(_year) {
    let transformedDate = '';
    transformedDate = _year + '-01-01';
    return transformedDate;
  }

  getOrganization = (organizationID) => {
  	let data = {};
    if(organizationID>0) {
	  	  const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'organizations/' + organizationID;
        let data = {};

        this.serverRequest =
            axios
                .get(url, {headers: config})
                .then(function(result) {
                    data = result.data.data;
                    if(data.approved_at !== '') data.approved_at = this.transformDateToYear(data.approved_at);
                    data.parent_id = data.parent ? data.parent.id : null;
                    this.setState({
                        organizationData: data,
                        originalApprovedAt: data.approved_at,
                        dataFetched: true,
                        isLoading: false
                    });
                }.bind(this))
  	} else {
      data = Object.assign({}, organizationValues);
      data.type='community';
      this.setState({
        organizationData: data
      })
    }
  }

  updateUnlockedStatus = (year, unlocked) => {
    this.setState((prevState) => {
      const updatedAnnualReports = prevState.organizationData.annualReports.map((report) => {
        if (report.year === year) {
          return { ...report, unlocked };
        }
        return report;
      });

      return {
        organizationData: {
          ...prevState.organizationData,
          annualReports: updatedAnnualReports
        }
      };
    });
  };

  // ATTACH COMMUNITY / CONGREGATION FUNCTIONS

  onHandleAttachCommunity = (community) => {
    let organizationData = this.state.organizationData;
    organizationData.parent_id = community.id;
    this.setState({
      attachedCommunity: community,
      organizationData: organizationData,
      formDataUpdated: true
    })
  }

  onHandleDissociateComunity = () => {
    const token = sessionStorage.getItem('id_token');
    const config = { 'Authorization': 'Bearer '+ token};
    const organizationID = this.state.organizationData.id;
    const url = APP_URL_API + 'organizations/' + organizationID + '/parent/dissociate';

    const data = {};
    data._method = "patch";

    this.serverRequest =
          axios
              .post(url, data, {headers: config})
              .then(function(response) {
                let organizationData = this.state.organizationData;
                organizationData.parent = [];
                organizationData.parent_id = null;
                this.setState({
                  organizationData: organizationData
                })
      }.bind(this))
  }

  onHandleAttachCongregation = (congregation) => {
    let attachedCongregations = this.state.attachedCongregations;
    attachedCongregations.push(congregation);
    this.setState({
      attachedCongregations: attachedCongregations,
      formDataUpdated: true
    })
  }

  onHandleRegretAttachingCongregation = (id) => {
    let attachedCongregations = this.state.attachedCongregations;
    const index = attachedCongregations.indexOf(id);
    attachedCongregations.splice(index, 1);
    this.setState({
      attachedCongregations: attachedCongregations
    })
  }

  onHandleRegretAttachingCommunity = () => {
    let organizationData = this.state.organizationData;
    organizationData.parent_id = organizationData.parent ? organizationData.parent.id : null;
    this.setState({
      attachedCommunity: false,
      organizationData: organizationData,
      formDataUpdated: true
    })
  }

  onHandleDetachCongregation = (orgID) => {
    let congregations = this.state.organizationData.children;
    let organizationData = this.state.organizationData;
    const index = congregations.map(function(e) { return e.id; }).indexOf(orgID);
    congregations.splice(index, 1);
    organizationData.children = congregations;
    this.setState({
      organizationData: organizationData,
      formDataUpdated: true
    })
    this.onDetachCongregation(orgID);
  }

  onDetachCongregation = (orgID) => {
    const token = sessionStorage.getItem('id_token');
    const config = { 'Authorization': 'Bearer '+ token};
    const url = APP_URL_API + '/organizations/' + orgID + '/parent/dissociate';
    const data = {};
    data._method = "patch";

    this.serverRequest =
        axios
            .post(url, data, {headers: config})
            .then(function(response) {
              console.log(response);
            })
  }

  attachCongregations = (orgID) => {
    const token = sessionStorage.getItem('id_token');
    const config = { 'Authorization': 'Bearer '+ token};
    const organizationID = orgID ? orgID : this.state.organizationData.id;
    const data = {};
    data._method = "patch";

    this.state.attachedCongregations.forEach(function(congregation) {
        const url = APP_URL_API + 'organizations/' + organizationID + '/link/' + congregation.id;
        this.serverRequest =
          axios
              .post(url, data, {headers: config})
              .then(function(response) {
                console.log(response);
              })
      }.bind(this))
  }

  // FORM FUNCTIONS (SUBMIT, CHANGING A FIELD, PREPARING DATA FOR SENDING)

  onChange = (event) => {
    let organizationData = this.state.organizationData;
    const name= event.target.name;
    const value= event.target.value;
    organizationData[name] = value;

    this.setState({
      organizationData,
      formDataUpdated: true
    });
  }

  onChangeAccountingDate = (date) => {
    let organizationData = this.state.organizationData;
    if(date===null) {
      organizationData.accounting_period_begin = "";
      organizationData.accounting_period_end = "";
    } else {
      organizationData.accounting_period_begin = date._d.getFullYear() + '-' + ('0' + (date._d.getMonth()+1)).slice(-2) + '-' + ('0' + date._d.getDate()).slice(-2);

      let endDate = new Date();
      endDate.setFullYear(date._d.getFullYear()+1, date._d.getMonth(), date._d.getDate()-1);
      organizationData.accounting_period_end = endDate.getFullYear() + '-' + ('0' + (endDate.getMonth()+1)).slice(-2) + '-' + ('0' + endDate.getDate()).slice(-2);
    }

    this.setState({
      organizationData,
      formDataUpdated: true
    });
  }

  onValidateForm(valid) {
    this.setState({formValid: valid});
  }

  prepareDataForsending = (data) => {
    /* remove all empty fields except approved_at, since the API can't handle if we send fields with a
    value of empty string or null
    */
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
          if ((data[key] === null || data[key] === '') && key!=='approved_at' && key!=='vat_number' && key!=='website' && key!=='beliefs_comments' && key!=='rituals_comments') {
              delete data[key];
            } else if (key==='approved_at' && data[key] === '') {
              data[key] = null;
            }
      }
    }
    // remove keys not needed when sending.
    let keys = ['parent', 'annualReports','associatedAnnualReports','type_name','children','documents', 'donations','memberships','new_beliefs','new_rituals','new_regulations','category_name'];
    if(this.props.user.type==="user") {
      const user_keys = ['category_id','type','name','approved_at','address','city','zip_code','website','is_public'];
      keys = keys.concat(user_keys)
    }
    keys.forEach(function(key) {
      delete data[key];
    });
    return data;
  }

  submit = (type) => {
    const token = sessionStorage.getItem('id_token');
    const config = { 'Authorization': 'Bearer '+ token};
    const data = this.state.organizationData;
    let redirectUserToPath = '';

    // format date before sending it (only when user is of type admin)
    if(this.props.user.type==="admin") {
      if(data.approved_at && data.approved_at !== '') { data.approved_at = this.transformYearToDate(data.approved_at) }
    }
    let url;
    let preparedData = Object.assign({}, data);
    preparedData = this.prepareDataForsending(preparedData);

    if(this.state.organizationData.id>0) {
      url = APP_URL_API + 'organizations/' + this.state.organizationData.id;
      delete preparedData['id'];
      delete preparedData['vat_number'];
      preparedData._method = "patch";
      redirectUserToPath = '/admin/organizations/';
    } else {
      url = APP_URL_API + 'organizations';
      delete preparedData['id'];
    }

    this.serverRequest =
        axios
            .post(url, preparedData, {headers: config})
            .then(function(response) {
              // Enable submit button when we have a response from the server
              this.setState({
                btnSubmitDisabled: false
              });
              this.uploadFiles(response.data.data.id);
              this.attachCongregations(response.data.data.id);
              if(type==="save") {
                this.setState({ isLoading: true, formDataUpdated: false});
                var intervalId = window.setInterval(function() {
                  if(!this.state.isUploadingFile) {
                    this.getOrganization(response.data.data.id);
                    clearInterval(intervalId);
                    setTimeout(function() {
                      this.props.history.replace('/admin/organization/'+response.data.data.id+'/edit/');
                    }.bind(this), 1000);
                  }
                }.bind(this), 1000);
              } else {
                this.props.history.replace(redirectUserToPath ? redirectUserToPath : '/admin/organization/'+response.data.data.id+'/edit/1');
              }
            }.bind(this))
  }

  onSubmit = (event, type) => {
    event.preventDefault();
    if(this.props.user.type==='user' && !this.state.formValid) {
      this.setState({
        modalText: 'Kontaktoplysninger og/eller regnskabsperiode mangler. Udfyld venligst oplysninger på trossamfundets/menighedens kontaktperson for at indberette oplysninger.',
        showAlertModal: true
      });
      return false;
    } else if(this.props.user.type==='admin' && !this.state.formValid) {
      this.setState({
        modalText: 'Navn, adresse og/eller årstal for godkendelse mangler eller er ikke udfyldt korrekt.',
        showAlertModal: true
      });
      return false;
    } else if(this.state.organizationData.type==='congregation'
      && !this.state.organizationData.parent_id) {
      this.setState({
        showInfoModal: true,
        saveType: type
      });
      return false;
    } else if(this.state.organizationData.approved_at !== this.state.originalApprovedAt) {
      if (window.confirm('Bemærk, at når du ændrer årstal for anerkendelse, slettes evt. afleverede filer før det nye anerkendelsesår. Er du sikker på at du vil fortsætte?')) {
        this.setState({
          btnSubmitDisabled: true
        });
        this.submit(type);
      }      
    } else {
      // Disable submit button to prevent multiple submissions
      this.setState({
        btnSubmitDisabled: true
      });
      this.submit(type);
    }
  }

  onShowInfoModal = (event, type) => {
    event.preventDefault();
    this.setState({
        showInfoModal: false
      });
    this.submit(this.state.saveType);
  }

  // HANDLING FILES

  uploadFiles = (id) => {
    if(this.state.files.regulations.file) {
      this.onHandleUploadFileToServer(this.state.files.regulations.file, 'regulations', id);
    }
    if(this.state.files.beliefs.file) {
      this.onHandleUploadFileToServer(this.state.files.beliefs.file, 'beliefs', id);
    }
    if(this.state.files.rituals.file) {
      this.onHandleUploadFileToServer(this.state.files.rituals.file, 'rituals', id);
    }
    if(this.state.files.annualReport.file) {
      this.onHandleUploadAnnualReportToServer(this.state.files.annualReport.file, id);
    }
    if(this.state.files.donations.file) {
      this.onHandleUploadDonationToServer(this.state.files.donations.file, id);
    }
  }

  onHandleFileDelete = (fieldname) => {
    let files = this.state.files;
    files[fieldname].file = null;
    files[fieldname].year = "";
    this.setState({
      files,
      formDataUpdated: true
    })
  }

  onHandlePrepareFileForUpload = (fieldname, file, comment, year, donations, donationsGreaterThan20000) => {
    let files = this.state.files;
    if(year) {
      files[fieldname].file = file;
      files[fieldname].year = year;
    } else {
      files[fieldname].file = file;
    }
    if(donations) {
      files[fieldname].donations = donations;
      files[fieldname].donationsGreaterThan20000 = donationsGreaterThan20000;
    }
    if(comment) files.comment = comment;
    this.setState({
      files,
      formDataUpdated: true
    })
  }

  onHandleUploadFileToServer = (file, document_type, document_id) => {
    const token = sessionStorage.getItem('id_token');
    const config = { 'Authorization': 'Bearer '+ token};
    const organizationID = document_id ? document_id : this.state.organizationData.id;
    const url = APP_URL_API + 'organizations/' + organizationID + '/file/document';
    const data = new FormData();
    let fileInfo = {
            documentType: document_type,
        };
    fileInfo = JSON.stringify(fileInfo);
    data.append("json", fileInfo);
    data.append("file", file);
    if(this.state.files.comment) data.append("comment", this.state.files.comment);

    // When file has been uploaded, remove file from memory.
    let files = this.state.files;
    files[document_type].file = '';
    files[document_type].comment = '';

    this.serverRequest =
        axios
            .post(url, data, {headers: config})
            .then(function(response) {
              this.setState({
                files: files
              })
            }.bind(this))
  }

  onHandleUploadAnnualReportToServer = (file, document_id) => {
    const token = sessionStorage.getItem('id_token');
    const config = { 'Authorization': 'Bearer '+ token};
    const organizationID = document_id ? document_id : this.state.organizationData.id;
    const url = APP_URL_API + 'organizations/' + organizationID + '/file/annualReport';
    const data = new FormData();
    data.append("file", file);
    data.append("donations", this.state.files.annualReport.donations);
    data.append("donations_greater_than20000", this.state.files.annualReport.donationsGreaterThan20000);
    data.append("year", this.state.files.annualReport.year);

    // When file has been uploaded, remove file from memory.
    let files = this.state.files;
    files['annualReport'].file = '';
    files['annualReport'].donations = '';

    this.state.isUploadingFile = true;

    this.serverRequest =
        axios
            .post(url, data, {headers: config})
            .then(function(response) {
              this.setState({
                files: files,
                isUploadingFile: false,
              })
            }.bind(this))
  }

  getUnlockedValue = (yearToFind) => {
    const { annualReports } = this.state.organizationData;
    const report = annualReports.find(report => report.year === yearToFind);
    if (report) {
      return report.unlocked;
    } else {
      return "";
    }
  };

  onHandleUploadDonationToServer = (file, document_id) => {
    const token = sessionStorage.getItem('id_token');
    const config = { 'Authorization': 'Bearer '+ token};
    const organizationID = document_id ? document_id : this.state.organizationData.id;
    const url = APP_URL_API + 'organizations/' + organizationID + '/file/donation';
    const data = new FormData();
    const year = this.state.files.donations.year;
    data.append("file", file);
    data.append("year", year);

    const unlocked = this.getUnlockedValue(year);
    if(unlocked) {
      data.append("forceQueue", true);
    }

    // When file has been uploaded, remove file from memory.
    let files = this.state.files;
    files['donations'].file = '';


    this.serverRequest =
        axios
            .post(url, data, {headers: config})
            .then(function(response) {
              this.setState({
                files: files
              })
            }.bind(this))
  }

  onHandleDelete = () => {
    const token = sessionStorage.getItem('id_token');
    const config = { 'Authorization': 'Bearer '+ token};
    const organizationID = this.state.organizationData.id;
    const url = APP_URL_API + 'organizations/' + organizationID;

    this.serverRequest =
        axios
            .delete(url, {headers: config})
            .then(function(response) {
                this.props.history.replace('/admin/organizations/')
            }.bind(this))
  }

  onBackToOverview = () => {
    this.props.history.replace('/admin/organizations/')
  }

  onHandleApproveDocument = (documentId, currentDocumentId, documentType) => {
    this.state.organizationData.documents[documentType].forEach(function(document, index) {
      let organizationData = this.state.organizationData;
      if(document.id === documentId) {
        organizationData.documents[documentType][index].approved_at = 'approved';
        this.approveDocumentOnServer(documentId);
        this.setState({
          organizationData: organizationData
        }, this.onHandleDeleteDocument(currentDocumentId, documentType))
      }
    }.bind(this))
  }

  approveDocumentOnServer = (documentId) => {
    const token = sessionStorage.getItem('id_token');
    const config = { 'Authorization': 'Bearer '+ token};
    const url = APP_URL_API + 'files/' + documentId + '/approveDocument';
    const data = {};
    data._method = "patch";

    this.serverRequest =
        axios
            .post(url, data, {headers: config})
            .then(function(response) {
            })
  }

  onHandleDeleteDocument = (documentId, doctype) => {
    this.state.organizationData.documents[doctype].forEach(function(document, index) {
      let organizationData = this.state.organizationData;
      if(document.id === documentId) {
        organizationData.documents[doctype].splice(index, 1);
        this.deleteDocumentFromServer(documentId);
        this.setState({
          organizationData: organizationData
        })
      }
    }.bind(this))
  }

  deleteDocumentFromServer = (documentId) => {
    const token = sessionStorage.getItem('id_token');
    const config = { 'Authorization': 'Bearer '+ token};
    const url = APP_URL_API + 'files/' + documentId;

    this.serverRequest =
        axios
            .delete(url, {headers: config})
            .then(function(response) {
            })
  }

  // REPORTS (annual reports, memberships)

  onHandleAddMembersCount = (year, count) => {
    let organizationData = this.state.organizationData;
    let memberships = this.state.memberships;
    let pos;
    // Check if array with key "year" exist and update count instead of adding to array
    pos = memberships.map(function(e) { return e.year; }).indexOf(year);
    if(pos > -1) {
      memberships[pos].count = count;
    } else {
      memberships.push({year: year, count: count, status: "new"});
    }
    this.setState({
      memberships: memberships,
      formDataUpdated: true
    })
  }

  onToggleModal = () => {
      if(this.state.showAlertModal) {
          this.setState({
              showAlertModal: false,
              accept: false
          });
      } else {
          this.setState({
              showAlertModal: true
          })
      }
  }

  onHandleDeleteAnnualReportAndDonations = () => {
  }

  render() {

    let information = [];
    if(this.props.match.params.id) {
      if(this.state.organizationData.id>0) {
        information.push(<Information
          organization={this.state.organizationData}
          onChange={this.onChange}
          onChangeAccountingDate={this.onChangeAccountingDate}
          type={this.state.organizationData.type}
          parent_id={this.state.organizationData.parent_id}
          user={this.props.user}
          onValidateForm={this.onValidateForm}
          key="1" />);
      }
    } else {
      information.push(<Information
        organization={this.state.organizationData}
        type={this.state.organizationData.type}
        parent_id={this.state.organizationData.parent_id}
        onChange={this.onChange}
        onChangeAccountingDate={this.onChangeAccountingDate}
        user={this.props.user}
        onValidateForm={this.onValidateForm} key="1" />);
    }

    const {error} = this.state;
    if(error) {
      return(
        <div>Fejl: {error.response.data.message}</div>
      )
    } else if (this.state.isLoading) {
        return ( <div className="isLoading"><div>Indlæser...</div></div> )
    } else {
    return(
      <div>
				<Header user={this.props.user} history={this.props.history}>
          {this.props.user.type === 'admin' && <nav className="navigation">
            <ul className="navigation__list">
              <li className="navigation__listitem"><a href="/admin/organizations/">Oversigt</a></li>
              <li className={!this.props.match.params.id ? 'navigation__listitem active' : 'navigation__listitem '}><a href="/admin/organization/create">Opret</a></li>
              <li className="navigation__listitem"><a href="/admin/organizations/settings">Indstillinger</a></li>
            </ul>
          </nav>}
        </Header>

        {this.props.user.type==="user" && <PrivacyAlert />}

        {this.props.user.type==="user" && <Alert organizationId={this.state.organizationData.id} />}
        {this.props.user.type==="user" && <Info organizationId={this.state.organizationData.id} />}

        <form>
          <div className="edit_or_create_organization">

            {information}

  					{this.state.dataFetched && this.state.organizationData.id && <Reports organization={this.state.organizationData}
              updateUnlockedStatus={this.updateUnlockedStatus}
              onHandleAddMembersCount={this.onHandleAddMembersCount}
              onHandlePrepareFileForUpload={this.onHandlePrepareFileForUpload}
              onHandleFileDelete={this.onHandleFileDelete}
              deleteDocumentFromServer={this.deleteDocumentFromServer}
              file={this.state.files.annualReport ? this.state.files.annualReport.file : ''}
              file2={this.state.files.donations ? this.state.files.donations.file : ''}
              formDataUpdated={this.state.formDataUpdated}
              user={this.props.user} />}

  					{this.props.user.type==="admin" &&
              <Settings organization={this.state.organizationData} onChange={this.onChange} showResetPassword={this.props.match.params.new} />
            }

                {this.state.dataFetched &&
                <Regulations file={this.state.files.regulations.file}
                  onHandleFileUpload={this.onHandlePrepareFileForUpload}
                  onHandleFileRemoval={this.onHandleFileRemoval}
                  documents={this.state.organizationData.documents.regulations}
                  onHandleDeleteDocument={this.onHandleDeleteDocument}
                  onHandleApproveDocument={this.onHandleApproveDocument}
                  user={this.props.user}
                />}
                {this.state.dataFetched && this.state.organizationData.type==="community" &&
                  <Beliefs file={this.state.files.beliefs.file}
                    onHandleFileUpload={this.onHandlePrepareFileForUpload}
                    onHandleFileRemoval={this.onHandleFileRemoval}
                    documents={this.state.organizationData.documents.beliefs}
                    onHandleDeleteDocument={this.onHandleDeleteDocument}
                    onHandleApproveDocument={this.onHandleApproveDocument}
                    comment={this.state.organizationData.beliefs_comments}
                    onChange={this.onChange}
                    user={this.props.user}
                  />}
                  {this.state.dataFetched && this.state.organizationData.type==="community" &&
                  <Rituals file={this.state.files.rituals.file}
                    onHandleFileUpload={this.onHandlePrepareFileForUpload}
                    onHandleFileRemoval={this.onHandleFileRemoval}
                    documents={this.state.organizationData.documents.rituals}
                    onHandleDeleteDocument={this.onHandleDeleteDocument}
                    onHandleApproveDocument={this.onHandleApproveDocument}
                    comment={this.state.organizationData.rituals_comments}
                    onChange={this.onChange}
                    user={this.props.user}
                  />}

  					{this.state.organizationData.type &&
              <SelectOrganization
                organization={this.state.organizationData}
                user={this.props.user}
                onHandleDissociateComunity={this.onHandleDissociateComunity}
                onHandleAttachCommunity={this.onHandleAttachCommunity}
                attachedCommunity={this.state.attachedCommunity}
                attachedCongregations={this.state.attachedCongregations}
                onHandleRegretAttachingCommunity={this.onHandleRegretAttachingCommunity}
                onHandleRegretAttachingCongregation={this.onHandleRegretAttachingCongregation}
                onHandleAttachCongregation={this.onHandleAttachCongregation}
                onHandleDetachCongregation={this.onHandleDetachCongregation} />}
  				</div>

          <Modal visible={this.state.showAlertModal}>
            <p>{this.state.modalText}</p>
            <div style={{marginTop: '3em', textAlign: 'right', minWidth: '400px'}}>
                <button type="button" className="button" onClick={() => this.onToggleModal()}>Ok</button>
            </div>
          </Modal>

          <Modal visible={this.state.showInfoModal}>
            <p>Du er ved at oprette en menighed uden tilknytning til et trossamfund. Vær opmærksom på at en menighed uden tilknytning til et trossamfund ikke fremgår på hjemmesiden.</p>
            <div style={{marginTop: '3em', textAlign: 'right', minWidth: '400px'}}>
                <button type="button" className="button" onClick={(e) => this.onShowInfoModal(e, this.state.saveType)}>Ok</button>
            </div>
          </Modal>

          <FooterButtons
            onHandleDelete={this.onHandleDelete}
            user={this.props.user}
            organizationId={this.state.organizationData.id}
            onBackToOverview={this.onBackToOverview}
            formDataUpdated={this.state.formDataUpdated}
            formValid={this.state.formValid}
            onSubmit={this.onSubmit}
            btnSubmitDisabled={this.state.btnSubmitDisabled} />

				</form>
			</div>
			);
    }
    }
	}

export default withAuth(OrganizationCreateOrEdit);


// WEBPACK FOOTER //
// ./src/modules/admin/organization/CreateOrEdit.js